import apiClient from "../api/apiClient"
import { PurchaseInvoice, PaginatedResponse } from "../../types"

export interface PurchaseInvoiceListParams {
  page?: number
  limit?: number
  vendor_name?: string
  from_date?: string
  to_date?: string
}

export interface RecordPaymentData {
  amount: number
  payment_date?: string
  remarks?: string
  payment_account?: 'cash' | 'bank'
  bank_account_id?: string
}

export interface CreatePurchaseInvoiceData {
  vendor_id: string
  invoice_date: string
  is_paid?: boolean
  payment_account?: 'cash' | 'bank'
  bank_account_id?: string
  line_items: {
    sku_id: string
    quantity_ctn: number
    quantity_pcs: number
    rate: number
    net_value_before_tax: number
  }[]
  summary: {
    net_value_before_tax: number
  }
  remarks?: string
}

export const purchaseInvoiceService = {
  async getPurchaseInvoices(
    params?: PurchaseInvoiceListParams
  ): Promise<PaginatedResponse<PurchaseInvoice>> {
    const response = await apiClient.get<{
      info: {
        page: number
        limit: number
        total: number
        totalPages: number
        hasNextPage: boolean
      }
      results: PurchaseInvoice[]
    }>("/admin/purchase-invoices", { params })

    return {
      data: response.data.results,
      total: response.data.info.total,
      page: response.data.info.page,
      limit: response.data.info.limit,
      totalPages: response.data.info.totalPages,
    }
  },

  async createPurchaseInvoice(data: CreatePurchaseInvoiceData): Promise<PurchaseInvoice> {
    const response = await apiClient.post<{ message: string; invoice: PurchaseInvoice }>(
      "/admin/purchase-invoices",
      data
    )
    return response.data.invoice
  },

  async getPurchaseInvoiceById(id: string): Promise<PurchaseInvoice> {
    const response = await apiClient.get<PurchaseInvoice>(`/admin/purchase-invoices/${id}`)
    return response.data
  },

  async recordPayment(id: string, data: RecordPaymentData): Promise<PurchaseInvoice> {
    const response = await apiClient.post<{ message: string; invoice: PurchaseInvoice }>(
      `/admin/purchase-invoices/${id}/payment`,
      data
    )
    return response.data.invoice
  },
}
